export default __webpack_public_path__ + "static/media/sari (6).218b63da.jpeg";